import React, {useContext} from "react";
import {useForm, FormProvider} from "react-hook-form";

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';

import * as CustomStyles from '../styles/CustomStyles';
import * as ClientFragment from './ClientFragmentComponent';
import {TabPanel, a11yProps} from "../custom/CustomTabPanelComponent";
import BucketContext from "../context/BucketContext";



const TabBottomButtonBar = (props) => {
    return (
        <Grid container spacing={2} sx={CustomStyles.gridStyles}>
            <React.Fragment>
                <Grid item xs={12} container justifyContent="flex-end" alignItems="flex-end">
                    <Button variant="outlined" type="submit" sx={{ marginRight: 1 }}> {props.buttonLabel} </Button>
                </Grid>
            </React.Fragment>
        </Grid>
    );
}


function ClientTabsRenderer(props) {
    console.log('client tab renderer');

    const bucketContext = useContext(BucketContext);

    const methods = useForm({
        defaultValues: {
            lClient: props.client
        }
    });
    const handleSubmit = methods.handleSubmit;

    const clientTabIndex = bucketContext.bucket.clientTabIndex != null ? bucketContext.bucket.clientTabIndex : 0;

    const [tabIndex, setTabIndex] = React.useState(clientTabIndex);
    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
        bucketContext.setBucketValue({ clientTabIndex: newValue });
    };

    const handleSubmitGeneralData = (data) => {
        const client = {
            id: data.lClient.id,
            generalSection: data.lClient.generalSection,
            clientDetails: data.lClient.clientDetails
        }
        props.patchClient(client);
    }

    const handleSubmitHeadOffice = (data) => {
        const client = {
            id: data.lClient.id,
            headOffice: data.lClient.headOffice
        }
        props.patchClient(client);
    }

    return (
        <React.Fragment>

            <FormProvider {...methods} >
                <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={tabIndex} onChange={handleTabChange} aria-label="scrollable tabs" variant="scrollable" scrollButtons="auto">
                            <Tab label="Date Generale" {...a11yProps(0)} />
                            <Tab label="Adresa Sediu" {...a11yProps(1)} />
                            <Tab label="Subcantractanti" {...a11yProps(2)} />
                            <Tab label="Subcontractant" {...a11yProps(3)} />
                        </Tabs>
                    </Box>

                    <TabPanel value={tabIndex} index={0}>
                        <form onSubmit={handleSubmit(handleSubmitGeneralData)} id={'generalDataTabForm'}>
                            <ClientFragment.RenderGeneralSection 
                                allClients={props.allClients}
                            />
                            <ClientFragment.RenderCompanySection />
                            <TabBottomButtonBar
                                clientId={props.client.id}
                                buttonLabel='Salveaza Date Generale'
                            />
                        </form>
                    </TabPanel>

                    <TabPanel value={tabIndex} index={1}>
                        <form onSubmit={handleSubmit(handleSubmitHeadOffice)} id={'homeOfficeTabForm'}>
                            <ClientFragment.RenderAdresaSediuSection />
                            <TabBottomButtonBar
                                clientId={props.client.id}
                                buttonLabel='Salveaza Sediu'
                            />
                        </form>
                    </TabPanel>

                    <TabPanel value={tabIndex} index={2}>
                        <ClientFragment.RenderSubcontractantiSection 
                            clientSubcontractanti={props.clientSubcontractanti}
                            allClients={props.allClients}
                        />
                    </TabPanel>

                    <TabPanel value={tabIndex} index={3}>
                        <ClientFragment.RenderSubcontractantSection 
                            allClients={props.allClients}
                            clientSubcontracted={props.clientSubcontracted}
                        />
                    </TabPanel>
                </Box>
            </FormProvider>
        </React.Fragment>
    );
}

export default ClientTabsRenderer